import React, { memo, useState } from "react";
import { Box, Toolbar } from "@mui/material";
import style from "./countryModal.module.css";
import { AiOutlineClose } from "react-icons/ai";
import { BiSearch } from "react-icons/bi";
import { BsCheckLg } from "react-icons/bs";
import { ReactComponent as CloseIcon } from "../../assets/closeIcon.svg";

function CountryModal({ close, setState, data, defaultSelected }) {
  const [search, setSearch] = useState("");

  const handleSearchCountry = (e) => {
    setSearch(e.target.value);
  };

  const getCountiesData = (arr) => {
    if (arr?.length === 0) {
      return <NoData />;
    }
    return arr?.map((item, index) => {
      const { callingCodes, name, flag } = item;
      return (
        <Box
          key={index}
          className={style.items_box}
          sx={{ display: "flex", justifyContent: "space-between" }}
          onClick={() => {
            setState({
              country_code: callingCodes,
              country_name: name,
              flag: flag,
            });
            close();
          }}
        >
          <div className={style.row_items}>
            <img src={flag} className="flag" alt={`${name} flag`} />
            <h5>+{callingCodes}</h5>
            <h4 style={{ color: "black" }}>{name}</h4>
          </div>
          <div>
            {defaultSelected === name && (
              <BsCheckLg
                style={{
                  color: "green",
                  stroke: "green",
                  strokeWidth: "2px",
                }}
              />
            )}
          </div>
        </Box>
      );
    });
  };

  const NoData = () => (
    <Box>
      <h4>No Data Found!</h4>
    </Box>
  );

  const getCountryData = getCountiesData(data);

  const filteredData = getCountiesData(
    data?.filter((x) =>
      (x.callingCodes + x.name.toLowerCase()).includes(search?.toLowerCase())
    )
  );

  return (
    <Box className={style.container} style={{ height: "100vh" }}>
      <Toolbar
        className={style.header}
        sx={{
          backgroundColor: "#f07821",
          display: "flex",
          justifyContent: "space-between",
          padding: "0 1rem",
          minHeight: 45
        }}
      >
        <h4 style={{ fontSize: "1rem", color: "white", fontWeight: 500 }}>
          Select Country Code
        </h4>
        <CloseIcon
          style={{ width: 25, height: 25, color: "white", cursor: "pointer" }}
          onClick={() => close()}
        />
      </Toolbar>

      <Box sx={{ margin: "1rem" }}>
        <Box className={style.searchBar}>
          <BiSearch className={style.searchIcon} />
          <input
            placeholder="Search country or code"
            onChange={handleSearchCountry}
            autoFocus
          />
        </Box>
        <div
          style={{
            overflowY: "auto",
            height: "80vh",
            marginTop: "1.5rem",
            paddingRight: "4px",
          }}
        >
          <Box>{!search ? getCountryData : filteredData}</Box>
        </div>
      </Box>
    </Box>
  );
}

export default memo(CountryModal);
